<template>
  <v-container>
    <!-- Used to display the list of employees based on workplace id -->
    <CompanyEmployeeList
      type="employed"
      :tabId="$route.params.tab"
      :MessageBoxText="$t('company.show-department-text', {departments: getCurrentUserDepartments($route.params.id, isAdministrator, isDepartmentAdministrator($route.params.id),isCompanyEducationResponsible($route.params.id), false)})"
      :isDepartments="hasDepartments($route.params.id)"
      :initialWorkplace="filter_workplace_id"
    />    
  </v-container>
</template>

<script>
import CompanyEmployeeList from '@/components/Company/CompanyEmployeeList'
import {CompanyRoles} from '@/components/mixins'
import {mapGetters, mapActions} from 'vuex'

// @group Company
// CompanyEmployees component
export default {
  name: 'CompanyEmployees',

  mixins: [CompanyRoles],
  
  props: {
    // workplace id
    filter_workplace_id: {
      // `Number`
      type: Number,
      required: false
    }
  },
  data() {
    return {
      // hasDepartments: true
    }
  },
  components: {
    CompanyEmployeeList
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isAdministrator', 'isDepartmentAdministrator', 'isCompanyEducationResponsible'])
  },
  created(){
  //  console.log("curr:::", this.currentUser)
  }
}
</script>